import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'equals',
  standalone: true,
  pure: true,
})
export class EqualsPipe implements PipeTransform {
  /**
   * Compare two values for equality.
   * Supports comparing by a specific key for objects.
   *
   * @param value - The first value to compare
   * @param compareWith - The second value to compare
   * @param key - Optional key to compare objects by (e.g., 'id')
   *
   * @example
   * // Simple equality
   * {{ value | equals:otherValue }}
   *
   * @example
   * // Compare objects by id
   * {{ constraint | equals:selectedConstraint:'id' }}
   */
  transform(value: any, compareWith: any, key?: string): boolean {
    if (value == null && compareWith == null) {
      return true;
    }

    if (value == null || compareWith == null) {
      return false;
    }

    if (key) {
      return value[key] === compareWith[key];
    }

    return value === compareWith;
  }
}
